import "./index.css";
import RenderRoutes from "./structure/Routes";
import { PopupProvider } from "./store/PopupContext";
import OrientationGuard from "./OrientationGuard"; // <- novo

function App() {
  return (
    <PopupProvider>
      <OrientationGuard>
        <RenderRoutes />
      </OrientationGuard>
    </PopupProvider>
  );
}

export default App;
